import { timeLabel } from "@/components/staff/categories";

export const WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const ORD = ["", "1st", "2nd", "3rd", "4th", "5th"];

export const isoWeekday = (date) => (date.getDay() + 6) % 7;

export const occursOn = (s, date) =>
  isoWeekday(date) === s.weekday && (!s.weeks?.length || s.weeks.includes(Math.ceil(date.getDate() / 7)));

export const describe = (s) => {
  const day = WEEKDAYS[s.weekday];
  const when = s.weeks?.length ? `Every ${s.weeks.map((w) => ORD[w]).join(" & ")} ${day} of the month` : `Every ${day}`;
  return `${when} · ${timeLabel(s.time)}`;
};

export const scheduleLabel = (s) => `${s.title} · ${WEEKDAYS[s.weekday].slice(0, 3)} ${timeLabel(s.time)}${s.note ? ` (${s.note})` : ""}`;
